export default "__VITE_ASSET__CqYl8$t6__"